<script>
		import { user, game, view } from "../client.svelte.js"
		import {Incepts, is_observed} from "../core.js";
	  import Occurred from "./Occurred.svelte";
	  import Imminent from "./Imminent.svelte";
		import {fly, fade} from "svelte/transition";
	  import Upcoming from "./Upcoming.svelte";
	  import TimelineHandle from "./TimelineHandle.svelte";

		let hiddenInfoIDs = $state([])
		let inceptions = $derived(
			view.upcomings.values()
				.filter(incid => (Incepts.includes(incid.ZUB) && incid.status === 'upcoming' && incid.time <= game.time + 1))
				.filter(incid => is_observed(incid, game.playables))
				.toArray()  )
		let imminents = $derived(
			view.upcomings.values()
				.filter(incid => (incid.status === 'upcoming' && incid.time <= game.time && !Incepts.includes(incid.ZUB))  || incid.status === 'querying')
				.filter(incid => is_observed(incid, game.playables))
				.toArray()  )
		let ongoings  = $derived(
			view.upcomings.values()
				.filter(incid => incid.status === 'ongoing')
				.filter(incid => is_observed(incid, game.playables))
				.toArray()  )
		let occurreds = $derived(Array.from(view.occurreds.values())
			.filter(incid => incid.status === 'occurred')
			//.toArray()
			.toReversed())

    // $inspect(`TIMELINE - imminents`, imminents)


	//ToDo: have new occorreds removed after 20s  (https://svelte.dev/playground/63222c181a164aebac4503cc09b2627c?version=5.23.0)
	function remove_occurred() {
		hiddenInfoIDs.push(this.ID)
	}
</script>


<!-------------------------------- HTML -------------------------------------->

<div id="timeline" transition:fly={{x: '100%', duration: 2000}}>
	<TimelineHandle/>
	<div class="timeline-scroll" data-help="timeline">
	{#if inceptions.length > 0}
		<h3>Startende Handlungen</h3>
		<div id=iceptionsBox class:masterView={user.isMaster}>
			{#each inceptions as upcoming (upcoming.ID)}
				<Upcoming {upcoming} />
			{/each}
		</div>
		<br>
	{/if}

	{#if imminents.length > 0}
		<h3>Handlungs-Ereignisse</h3>
		<div id=imminentBox class:masterView={user.isMaster}>
			{#each imminents as imminent (imminent.ID)}
				<Imminent {imminent} />
			{/each}
		</div>
	{/if}

	<div id=ongoingBox >
		{#each ongoings as info (info.ID)}
			<Occurred {info}/>
		{/each}
	</div>
	<div id=occurredBox >
		{#each Array.from(view.occurreds.values()).toReversed() as info (info.ID)}
			<Occurred {info}/>
		{/each}
	</div>
	</div>
</div>


<!-------------------------------- STYLE -------------------------------------->

<style lang="sass">
	@use "../colors" as colors

	#timeline
		position: absolute
		right: 0
		top: 80px
		width: 360px
		bottom: 0
		z-index: 8

	:global(.master) #timeline
		width: 420px

	/* inner box scrolls, so the handle on the left side is not clipped */
	.timeline-scroll
		height: 100%
		box-sizing: border-box
		padding: 4px 4px 0 4px
		overflow: auto
		scrollbar-width: none
		background: black url("/static/images/background-light.png")
		opacity: 80%

		&::-webkit-scrollbar
			display: none

	#filterBox
		height: 4em
		margin-bottom: 13px
		padding: 14px 6px

	#tickerFilter
		height: 42px
		background: papayawhip
		opacity: 100%

	#occurredBox
		background: #222222 url("/static/images/parchment.png") repeat 0 0
		/* border-image: url(https://i.imgur.com/040pFDw.png) 20 / 20px round */
		box-sizing: border-box
		color: black
		/* overflow: hidden /* to prevent margin collapsing */
		display: flow-root /* to prevent margin collapsing */

	#ongoingBox
		background-color: navajowhite

	/**** IMMINENT box ****/

	#imminentBox
		bottom: 0
		border-radius: 10px
		border: 2px solid white
		box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)
		background-color: colors.$grey-30
</style>